import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { ModalController } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';

export interface ConfirmModalDismissData {
  isRedBtnClick?: boolean;
  isGrayBtnClick?: boolean;
}

export interface ConfirmModalProps {
  header: string;
  subTitle: string;
  redBtnLabel?: string;
  grayBtnLabel?: string;
  cssClass?: string;
  redBtnHidden?: boolean;
}

@Component({
  selector: 'pos-confirm-modal',
  templateUrl: './confirm.modal.html',
  styleUrls: ['./confirm.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmModal {
  @Input() header: string;
  @Input() subTitle: string;
  @Input() redBtnLabel: string;
  @Input() grayBtnLabel: string;
  @Input() cssClass: string;
  @Input() redBtnHidden = false;

  readonly faTimes = faTimes;

  constructor(
    private readonly modalCtrl: ModalController,
    private readonly translocoService: TranslocoService
  ) {
    // Set default translated button labels
    this.redBtnLabel = this.translocoService.translate('common.no');
    this.grayBtnLabel = this.translocoService.translate('common.yes');
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  onClick(isGrayBtn: boolean) {
    if (isGrayBtn) {
      this.modalCtrl.dismiss({ isGrayBtnClick: true });
    } else {
      this.modalCtrl.dismiss({ isRedBtnClick: true });
    }
  }
}
